import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  Col,
  Descriptions,
  Row,
  Space,
  Popconfirm,
  Image,
} from "antd";
import { ReactComponent as DeleteSvg } from "../../../../assets/images/action/deleteWhite.svg";
import { ReactComponent as PersonSvg } from "../../../../assets/images/description/person.svg";
import { ReactComponent as AboutSvg } from "../../../../assets/images/description/Notes.svg";
import { ReactComponent as CrownSvg } from "../../../../assets/images/description/Crown.svg";
import { ReactComponent as HomeSvg } from "../../../../assets/images/description/home.svg";
import { ReactComponent as CategorySvg } from "../../../../assets/images/description/category.svg";
import { ReactComponent as PodcastSvg } from "../../../../assets/images/description/Mic.svg";
import { ReactComponent as ImageSvg } from "../../../../assets/images/description/Videos.svg";
import { useLocation, useNavigate } from "react-router";
import {
  deletePodcast,
  viewPodcast,
  viewPodcastActivity,
} from "../../../../redux/reducer/ManagePodcastSlice";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined } from "@ant-design/icons";
import ContentScalaton from "../../../../components/scalaton/ContentScalaton";
import { toast } from "react-toastify";
import { Table, Rate } from 'antd';

const ViewPodcast = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [podcastPlay, setPodcastPlay] = useState(false);
  const [podcastMp3, setPodcastMp3] = useState("");
  const audioRef = useRef(null);

  const padcastData = location.state?.celebrityData;
  const [isPlaying, setIsPlaying] = useState(false);

  const { viewPodcastData, viewPodcastActivityData, viewPodcastLoading } = useSelector(
    (prev) => prev?.managePodcast
  );



  useEffect(() => {
    if (padcastData) {
      dispatch(viewPodcast(padcastData?.id));
      dispatch(viewPodcastActivity(padcastData?.id))
      setPodcastPlay(true);
    }
  }, [dispatch, padcastData]);

  const handleDelete = async (id) => {
    try {
      const data = await dispatch(deletePodcast(id));

      if (data?.type === "data/delete/podcast/fulfilled") {
        toast.success("Podcast Deleted Successfully");
        navigate("/manage-podcast");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (viewPodcastData?.file_url_en || viewPodcastData.file_url_es || viewPodcastData.file_url_pt) {
      const newUrl = `${process.env.REACT_APP_IMAGE_URL}/${viewPodcastData.file_url_en ?? viewPodcastData.file_url_es ?? viewPodcastData.file_url_pt}`;
      setPodcastMp3(newUrl);
    }
  }, [viewPodcastData]);

  // Reload the audio source when podcastMp3 updates
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.load();
    }
  }, [podcastMp3]);

  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const data = [];

  const HomeArray = viewPodcastData?.HomeCategoryTags?.map(
    (item) => item?.name_en
  );
  const PodacstArray = viewPodcastData?.PodcastCategories?.map(
    (item) => item?.name_en
  );
  const SubscriptionArray = viewPodcastData?.SubscriptionPlans?.map(
    (item) => item?.name_en
  );
  const CelebrityArray = viewPodcastData?.CelebrityMasters?.map(
    (item) => item?.name_en
  );

  const columns = [
    {
      title: 'User Name',
      dataIndex: 'user_name_en',
      key: 'userName',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'userEmail',
    },
    {
      title: 'User Rating',
      dataIndex: 'rating',
      key: 'userRating',
      render: (rating) => rating,
    },
  ];

  const basicInfo_details = [
    {
      key: "1",
      label: (
        <>
          <PodcastSvg /> Podcast Title
        </>
      ),
      children: viewPodcastData?.title_en ?? viewPodcastData?.title_es ?? viewPodcastData?.title_pt ?? "N/A",
      span: 2,
    },
    // {
    //   key: "2",
    //   label: (
    //     <>
    //       <PersonSvg /> Author Name
    //     </>
    //   ),
    //   children: viewPodcastData?.AuthorMaster?.name ?? "N/A",
    //   span: 2,
    // },

    {
      key: "5",
      label: (
        <>
          <CrownSvg /> Subscription Plans
        </>
      ),
      children:
        (
          <ul>
            {SubscriptionArray?.map((name, index) => (
              <li key={index}>{name}</li>
            ))}
          </ul>
        ) ?? "user",
      span: 2,
    },
    {
      key: "6",
      label: (
        <>
          <PersonSvg /> Picked by Celebrity
        </>
      ),
      children:
        (
          <ul>
            {CelebrityArray?.map((name, index) => (
              <li className="list-none" key={index}>{name}</li>
            ))}
          </ul>
        ) ?? "N/A",
      span: 2,
    },
    {
      key: "7",
      label: (
        <>
          <HomeSvg /> Rating
        </>
      ),
      children: viewPodcastData?.rating ?? "N/A",
      span: 2,
    },
    {
      key: "7",
      label: (
        <>
          <PodcastSvg /> Total Play
        </>
      ),
      children: viewPodcastData?.total_listened_count ?? "N/A",
      span: 2,
    },
    {
      key: "7",
      label: (
        <>
          <PersonSvg /> Intended Audience
        </>
      ),
      children: viewPodcastData?.intended_audience_en ?? viewPodcastData?.intended_audience_es ?? viewPodcastData?.intended_audience_pt ?? "N/A",
      span: 2,
    },
    {
      key: "3",
      label: (
        <>
          <CategorySvg /> Podcast Category
        </>
      ),
      children:
        (
          <ul>
            {PodacstArray?.map((name, index) => (
              <p key={index}>
                 {name}
              </p>
            ))}
          </ul>
        ) ?? "user",
      span: 2,
    },
    {
      key: "4",
      label: (
        <>
          <HomeSvg /> Home Category
        </>
      ),
      children:
        (
          <ul>
            {HomeArray?.map((name, index) => (
              <li key={index}>{name}</li>
            ))}
          </ul>
        ) ?? "user",
      span: 2,
    },

    {
      key: "7",
      label: (
        <>
          <AboutSvg /> Short Description (Max 200 Words)
        </>
      ),
      children: viewPodcastData?.short_desc_en ?? viewPodcastData?.short_desc_es ?? viewPodcastData?.short_desc_pt ?? "N/A",
      span: 4,
    },
    {
      key: "8",
      label: (
        <>
          <AboutSvg /> Long Description (Max 500 Words)
        </>
      ),
      children: viewPodcastData?.desc_en ?? viewPodcastData?.desc_es ?? viewPodcastData?.desc_pt ?? "N/A",
      span: 4,
    },
  ];
  const author_details = [
    {
      key: "1",
      label: (
        <>
          <PersonSvg /> Name
        </>
      ),
      children: viewPodcastData?.AuthorMaster?.name ?? "N/A",
      span: 1,
    },
    {
      key: "1",
      label: (
        <>
          <PersonSvg /> Status
        </>
      ),
      children:
        viewPodcastData?.AuthorMaster?.status == 1
          ? "Active"
          : "Inactive" ?? "N/A",
      span: 1,
    },
    {
      key: "1",
      label: (
        <>
          <ImageSvg /> Image
        </>
      ),
      children: viewPodcastData?.AuthorMaster?.image_url ? (
        <img
          src={`${process.env.REACT_APP_IMAGE_URL}/${viewPodcastData.AuthorMaster.image_url}`}
          alt="Author"
          style={{
            width: "80px",
            height: "80px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        />
      ) : (
        "N/A"
      ),
      span: 1,
    },
    {
      key: "1",
      label: (
        <>
          <AboutSvg /> About
        </>
      ),
      children: viewPodcastData?.AuthorMaster?.about_en ?? viewPodcastData?.AuthorMaster?.about_es ?? viewPodcastData?.AuthorMaster?.about_pt ?? "N/A",
      span: 4,
    },
  ];
  const handleEdit = (data) => {
    if (data) {
      navigate("/manage-podcast/add-podcast", { state: { editData: data } });
    }
  };

  const fakeUserRatingData = [
    {
      key: '1',
      userName: 'Aarav Sharma',
      userRating: 4.2,
    },
    {
      key: '2',
      userName: 'Priya Verma',
      userRating: 3.8,
    },
    {
      key: '3',
      userName: 'Rahul Kapoor',
      userRating: 5.0,
    },
    {
      key: '4',
      userName: 'Sneha Patel',
      userRating: 2.9,
    },
    {
      key: '5',
      userName: 'Vikram Singh',
      userRating: 4.5,
    },
    {
      key: '6',
      userName: 'Divya Yadav',
      userRating: 3.5,
    },
   
   
  ];

  return (
    <>
      {/* Header Section */}
      <div className="customDescription">
        <div className="viewTenant">
          <div className="tableHeading">
            <ArrowLeftOutlined
              onClick={() => navigate(-1)}
              style={{ fontSize: "18px", marginRight: "10px" }}
            />
            View Podcast Details
          </div>
          <Space>
            <Popconfirm
              title={
                <span style={{ fontWeight: 600, fontSize: "16px" }}>
                  Delete Podcast?
                </span>
              }
              description={
                <span style={{ color: "#999" }}>
                  This action cannot be undone.
                </span>
              }
              onConfirm={() => handleDelete(padcastData?.id)}
              okText="Yes, Delete"
              cancelText="Cancel"
              okButtonProps={{ danger: true, style: { borderRadius: 6 } }}
              cancelButtonProps={{ style: { borderRadius: 6 } }}
              placement="topRight"
              overlayStyle={{ width: 300 }}
            >
              <Button
                type="primary"
                danger
                icon={<DeleteSvg />}
                className="delete"
                loading={false}
              >
                Delete
              </Button>
            </Popconfirm>
            {/* <Button
              type="danger"
              onClick={() => handleDelete(padcastData?.id)}
              icon={<DeleteSvg />}
              className="delete"
            >
              Delete
            </Button> */}
            <Button type="primary" onClick={() => handleEdit(padcastData)}>
              Edit Details
            </Button>
          </Space>
        </div>

        {/* Main Content */}
        <Card>
          {viewPodcastLoading ? (
            <ContentScalaton />
          ) : (
            <Row gutter={[16, 16]}>
              {/* Left Column (50%) - Podcast Details */}
              <Col xs={24} md={18}>
                <Descriptions
                  className="custom_descriptions"
                  layout="vertical"
                  items={basicInfo_details}
                  size="small"
                  column={{ xs: 1, sm: 2, md: 2 }}
                />
              </Col>

              <Col xs={24} md={6} className="podcast-image-container">
                <Image
                  src={`${process.env.REACT_APP_IMAGE_URL}/${viewPodcastData?.book_cover_en ?? viewPodcastData?.book_cover_es ?? viewPodcastData?.book_cover_pt}`}
                  alt="Podcast"
                  width="100%"
                  height={200}
                  style={{ objectFit: "contain", borderRadius: 8 }}
                />
                <div className="podcast-audio">
                  <audio
                    key={podcastMp3}
                    ref={audioRef}
                    controls
                    controlsList="nodownload"
                  >
                    <source src={podcastMp3} type="audio/mp3" />
                    Your browser does not support the audio tag.
                  </audio>
                </div>
              </Col>
              <div className="tableHeading">Author Details</div>
              <Descriptions
                className="custom_descriptions"
                layout="vertical"
                items={author_details}
                size="small"
                column={{ xs: 1, sm: 2, md: 2 }}
              />
               <Col xs={24} md={18}>
               <div className="tableHeading">User Rating List</div>
               </Col>
               <Col xs={24} md={18}>
                <Table dataSource={viewPodcastActivityData} columns={columns} pagination={false} />
              </Col>
            </Row>
          )}
        </Card>
      </div>
    </>
  );
};

export default ViewPodcast;

//   // Reload the audio source when podcastMp3 updates
//   useEffect(() => {
//     if (audioRef.current) {
//       audioRef.current.load();
//     }
//   }, [podcastMp3]);

//   // Toggle Play/Pause
//   const togglePlay = () => {
//     if (audioRef.current) {
//       if (isPlaying) {
//         audioRef.current.pause();
//       } else {
//         audioRef.current.play();
//       }
//       setIsPlaying(!isPlaying);
//     }
//   };

//   return (
//     <>
//       <div className="customDescription">
//         <div className="viewTenant">
//           <div className="tableHeading">
//             <ArrowLeftOutlined
//               onClick={() => navigate(-1)}
//               style={{ fontSize: "18px", marginRight: "10px" }}
//             />
//             View Podcast Details
//           </div>
//           <Space>
//             <Button type="danger" onClick={() => navigate(-1)}>Delete</Button>
//             <Button type="primary" onClick={() => navigate("/manage-podcast/add-podcast", { state: { editData: padcastData } })}>
//               Edit Details
//             </Button>
//           </Space>
//         </div>

//         {/* Main Content */}
//         <Card>
//           <Row gutter={[16, 16]}>
//             {/* Podcast Image */}
//             <Col xs={24} md={12} className="podcast-image-container">
//               <Image
//                 src={`${process.env.REACT_APP_IMAGE_URL}/${viewPodcastData?.book_cover_en}`}
//                 alt="Podcast"
//                 width="100%"
//                 height={200}
//                 style={{ objectFit: "contain", borderRadius: 8 }}
//               />
//               <div className="podcast-audio">
//                 <audio key={podcastMp3} ref={audioRef} controls controlsList="nodownload">
//                   <source src={podcastMp3} type="audio/mp3" />
//                   Your browser does not support the audio tag.
//                 </audio>
//               </div>
//             </Col>
//           </Row>
//         </Card>
//       </div>
//     </>
//   );
// };

// export default ViewPodcast;
